export type LocalePreference = 'auto' | 'tr' | 'en'
export type AppLocale = 'tr' | 'en'

export const LOCALE_STORAGE_KEY = 'servernoxLanguage'

export function normalizeLocalePreference(value: unknown): LocalePreference {
  return value === 'tr' || value === 'en' || value === 'auto' ? value : 'auto'
}

export function resolveLocalePreference(
  preference: LocalePreference,
  languages: readonly string[] = [],
): AppLocale {
  if (preference === 'tr' || preference === 'en') return preference
  const primary = String(languages[0] || '').trim().toLowerCase()
  return primary.split(/[-_]/)[0] === 'tr' ? 'tr' : 'en'
}

export function browserLanguages(): string[] {
  if (typeof navigator === 'undefined') return []
  if (Array.isArray(navigator.languages) && navigator.languages.length) return [...navigator.languages]
  return navigator.language ? [navigator.language] : []
}

export function loadLocalePreference(): LocalePreference {
  try {
    return normalizeLocalePreference(localStorage.getItem(LOCALE_STORAGE_KEY))
  } catch {
    return 'auto'
  }
}
